module.exports = __webpack_public_path__ + "static/img/how2.092491e5.png";